var _excluded = ["showRecent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesAutocomplete from '../allhomes-autocomplete';
import AutocompleteType from '../utils/autocomplete-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DIVISION = AutocompleteType.DIVISION,
  POSTCODE = AutocompleteType.POSTCODE,
  DISTRICT = AutocompleteType.DISTRICT,
  REGION = AutocompleteType.REGION,
  AGENT = AutocompleteType.AGENT,
  AGENCY = AutocompleteType.AGENCY;
var RECENT_SEARCH_KEY = 'agent-recent-searches';
var immediateTypes = [AGENT.name, AGENCY.name];
var AgentSearchAutocomplete = _ref => {
  var showRecent = _ref.showRecent,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(AllhomesAutocomplete, _extends({
    types: [DIVISION.name, POSTCODE.name, DISTRICT.name, REGION.name, AGENT.name, AGENCY.name],
    immediateTypes: immediateTypes,
    placeholder: "Type a location, agent or agency name",
    recentSearchKey: showRecent ? RECENT_SEARCH_KEY : undefined,
    saveRecentOnSearch: showRecent
  }, props));
};
AgentSearchAutocomplete.immediateTypes = immediateTypes;
AgentSearchAutocomplete.propTypes = {
  size: PropTypes.oneOf(['normal', 'large']),
  onSearch: PropTypes.func,
  showRecent: PropTypes.bool,
  onImmediateSearch: PropTypes.func,
  onRecentSearch: PropTypes.func
};
AgentSearchAutocomplete.defaultProps = {
  size: 'normal',
  showRecent: false,
  onSearch: () => {},
  onImmediateSearch: undefined,
  onRecentSearch: undefined
};
export default AgentSearchAutocomplete;